import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { RegexpTypes } from "@bappweb/utils"
import TextField from "@bappweb/textfield"
import Select from "@bappweb/select"
import AmountReview from "./lib/amountreview"
import Block from "@bappweb/block"
import { maxValueAmount, minValueAmount, requiredAmount } from "./lib/validations"
import "./assets/styles/style.scss"

class Amount extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      amount: {
        integerValue: 0,
        decimalValue: 0,
      },
      currency: {
        value: "888",
        label: "TL",
      },
    }

    this.handleIntegerPartChange = this.handleIntegerPartChange.bind(this)
    this.handleDecimalPartChange = this.handleDecimalPartChange.bind(this)
    this.handleDecimalPartBlur = this.handleDecimalPartBlur.bind(this)
    this.numberWithCommas = this.numberWithCommas.bind(this)
    this.calculateMaxLength = this.calculateMaxLength.bind(this)
    this.handlePickerChange = this.handlePickerChange.bind(this)
  }

  componentDidMount() {
    if (this.props && this.props.value) {
      this.initialise(this.props.value)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.props.value) {
      this.initialise(nextProps.value == null ? 0 : nextProps.value)
    }
  }

  initialise(value) {
    if (value && value.amount) {
      let amountValue = value.amount.toString().replace(/,/g, ".")
      let currency = value.currency

      if (amountValue.indexOf(".") >= 0) {
        this.setState({
          amount: {
            integerValue: parseInt(amountValue.split(".")[0]),
            decimalValue: amountValue.split(".")[1],
          },
        })
      } else {
        this.setState({
          amount: {
            integerValue: amountValue,
            decimalValue: 0,
          },
        })
      }

      if (currency) {
        let filteredValue = this.props.currencyList.filter(options => {
          return options.value === currency.value
        })

        if (filteredValue && filteredValue.length > 0) {
          this.setState({
            currency: filteredValue[0],
          })
        }
      }
    } else {
      this.setState({
        amount: {
          integerValue: 0,
          decimalValue: 0,
        },
      })
    }
  }

  handleIntegerPartChange(event) {
    let eventValue =
      event.target.value === "" ? 0 : event.target.value.replace(/\./g, "").replace(/[^0-9]+/, "")

    let amount = parseInt(eventValue) + parseFloat("." + this.state.amount.decimalValue)
    let value = { amount: amount, currency: this.state.currency }

    if (this.props.onChange) {
      this.props.onChange(event, value)
    }
  }

  handleDecimalPartChange(event) {
    let eventValue =
      event.target.value === "" ? 0 : event.target.value.replace(/\./g, "").replace(/[^0-9]+/, "")
    let amount = parseInt(this.state.amount.integerValue) + parseFloat("." + eventValue.toString())
    let value = { amount: amount, currency: this.state.currency }

    if (this.props.onChange) {
      this.props.onChange(event, value)
    }
  }

  handleDecimalPartBlur(event) {
    this.setState((previousState, currentProps) => {
      return {
        amount: {
          integerValue: previousState.amount.integerValue,
          decimalValue:
            previousState.amount.decimalValue.length === 1
              ? previousState.amount.decimalValue + "0"
              : previousState.amount.decimalValue,
        },
      }
    })
  }

  numberWithCommas(value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }

  calculateMaxLength(maxLength) {
    if (maxLength === 0) {
      return 0
    } else {
      if (maxLength % 3 === 0) {
        return maxLength + parseInt(maxLength / 3) - 1
      } else {
        return maxLength + parseInt(maxLength / 3)
      }
    }
  }

  handlePickerChange(event, dataObj) {
    this.setState({ currency: dataObj }, () => {
      let amount =
        parseInt(this.state.amount.integerValue) +
        parseFloat("." + this.state.amount.decimalValue.toString())
      let value = { amount: amount, currency: this.state.currency }

      if (this.props.onChange) {
        this.props.onChange(event, value)
      }

      if (this.props.onCurrencyChange) {
        this.props.onCurrencyChange(dataObj)
      }
    })
  }

  render() {
    let amountClasses = classNames(this.props.className, "amount-container", {})
    let alignment = this.props.align === "left" ? "align-left" : "align-right"
    let placeholder = this.props.placeholder ? this.props.placeholder : "00"

    return (
      <Block className={amountClasses}>
        <Block className="amount-whole">
          <Block>
            <TextField
              placeholder= {placeholder}
              type="text" /* type=number 7+ haneli sayılarda binler ayıracından dolayı problem çıkarıyor*/
              className={classNames("bapp-input", alignment)}
              name= { this.props.name ? this.props.name : "amount"}
              autoFocus={this.props.autoFocus}
              maxLength={this.calculateMaxLength(this.props.maxLength)}
              onChange={this.handleIntegerPartChange}
              validator={
                RegexpTypes.Version
              } /* Binler ayıracını kabul etmesi için Numeric yerine Version kullanmak gerekiyor */
              value={
                this.state.amount.integerValue === 0
                  ? ""
                  : this.numberWithCommas(this.state.amount.integerValue)
              }
              label={this.props.label}
              validations={this.props.validations}
            />
          </Block>
        </Block>
        {this.props.withDecimalPart && (
          <Block className="amount-decimal">
            <Block className="bapp-input-container">
              <TextField
                partofform={false}
                placeholder= {placeholder}
                type="tel"
                className={classNames("bapp-input", alignment)}
                name="decimals"
                maxLength={2}
                onChange={this.handleDecimalPartChange}
                onBlur={this.handleDecimalPartBlur}
                validator={RegexpTypes.Version}
                value={this.state.amount.decimalValue === 0 ? "" : this.state.amount.decimalValue}
                label={this.props.labelDecimal}
              />
            </Block>
          </Block>
        )}
        {this.props.withCurrency && this.props.currencyList && (
          <Block className="amount-currency">
            {this.props.currencyList.length > 1 ? (
              // if render SELECT to currency
              <Select
                partofform={false}
                name="select"
                value={this.state.currency.value}
                options={this.props.currencyList}
                onChange={this.handlePickerChange}
                clearable={false}
                backspaceRemoves={false}
              />
            ) : (
              // else render input with readonly
              <TextField
                partofform={false}
                placeholder="TL"
                type="text"
                name="currency"
                readOnly
                tabIndex={-1}
                value={this.props.currencyList[0].label}
                label={this.props.labelCurrency}
              />
            )}
          </Block>
        )}
      </Block>
    )
  }
}

Amount.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func,
  onCurrencyChange: PropTypes.func,
  maxLength: PropTypes.number,
  withDecimalPart: PropTypes.bool,
  withCurrency: PropTypes.bool,
  currencyList: PropTypes.array,
  autoFocus: PropTypes.bool,
  align: PropTypes.string,
  label: PropTypes.string,
  labelDecimal: PropTypes.string,
  labelCurrency: PropTypes.string,
}

Amount.defaultProps = {
  value: {
    amount: 0,
    currency: {
      value: "888",
      label: "TL",
    },
  },
  withDecimalPart: true,
  withCurrency: true,
  maxLength: 14,
  currencyList: [{ value: "888", label: "TL" }],
  align: "right",
}
/*eslint-disable */
Amount.Review = AmountReview
Amount.requiredAmount = requiredAmount
Amount.minValueAmount = minValueAmount
Amount.maxValueAmount = maxValueAmount
/*eslint-enable */
export default Amount
